import React, { useEffect, useState } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { aiAppVotesAPI, authAPI } from '../utils/api';

const AppRecommendationModal = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const [recommendation, setRecommendation] = useState(null);

  useEffect(() => {
    if (location.state?.appRecommendation) {
      const nextRecommendation = location.state.appRecommendation;
      setRecommendation(nextRecommendation);
      if (nextRecommendation.type === 'registrationOffer') {
        authAPI.markRegistrationOfferModalShown().catch(() => {});
      } else {
        aiAppVotesAPI.markRecommendationModalShown().catch(() => {});
      }
      navigate(location.pathname + location.search + location.hash, {
        replace: true,
        state: {}
      });
    }
  }, [location, navigate]);

  if (!recommendation) {
    return null;
  }

  const isRegistrationOffer = recommendation.type === 'registrationOffer';

  return (
    <div className="fixed inset-0 z-[1000] flex items-center justify-center bg-black bg-opacity-50 px-4">
      <div className="w-full max-w-md rounded-lg bg-white p-6 shadow-xl">
        <h3 className="text-lg font-semibold text-gray-900">
          {isRegistrationOffer ? `Добро пожаловать в ${recommendation.appName}` : 'Мы открыли ваше любимое приложение'}
        </h3>
        {isRegistrationOffer ? (
          <p className="mt-3 text-sm leading-6 text-gray-600">
            {recommendation.welcomeMessage}
          </p>
        ) : (
          <>
            <p className="mt-3 text-sm leading-6 text-gray-600">
              Мы обратили внимание, что чаще всего вы пользуетесь приложением «{recommendation.appName}»,
              поэтому сразу открыли его после входа.
            </p>
            <p className="mt-3 text-sm leading-6 text-gray-600">
              Если такой подход вам не нравится, рекомендации можно отключить в{' '}
              <Link
                to="/profile"
                className="font-medium text-blue-600 hover:text-blue-700"
                onClick={() => setRecommendation(null)}
              >
                профиле
              </Link>
              .
            </p>
          </>
        )}
        <div className="mt-6 flex justify-end">
          <button
            type="button"
            onClick={() => setRecommendation(null)}
            className="rounded-md bg-blue-600 px-4 py-2 text-sm font-medium text-white hover:bg-blue-700"
          >
            {isRegistrationOffer ? 'Протестировать' : 'Понятно'}
          </button>
        </div>
      </div>
    </div>
  );
};

export default AppRecommendationModal;
